import {errorMatcher, loadingMatcher} from "./types";

export const loadingStatusFor = (loading: Record<string, boolean>, actions?: string[]) => {
    if (!actions) {
        return Object.values(loading).some(status => status);
    }

    return actions
        .map(action => {
            const matches = loadingMatcher.exec(action);

            if (!matches) {
                return "";
            }

            const [, requestName,] = matches;

            return requestName;
        })
        .some(requestName => loading[requestName]);
};

export const errorMessageFor = (error: Record<string, string>, actions: string[]) => {
    return actions
        .map(action => {
            const matches = errorMatcher.exec(action);

            if (!matches) {
                return "";
            }

            const [, requestName,] = matches;

            return requestName;
        })
        .map(action => error[action])
        .shift();
};